module.exports = __webpack_public_path__ + "static/bg-487d3af0839b2bac852d53a64921e303.svg";